
    <h1 mat-dialog-title>Enter Adaptive Work ID</h1>
    <div mat-dialog-content>
      <mat-form-field>
        <mat-label>Adaptive Work ID</mat-label>
        <input matInput [(ngModel)]="data.adaptiveId" />
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button color="primary" (click)="onSave()">Create Project ID</button>
    </div>
  